
export const AREA_LIST = [
  {
    value: 'SH',
    label: 'ShangHai'
  },
  {
    value: 'CN',
    label: 'China'
  },
  {
    value: 'GLOBAL',
    label: 'Global'
  }
]

export const BU_LIST = [
  {
    value: '',
    label: 'All BUs'
  },
  {
    value: 'YFAI-AP',
    label: 'YFAI-AP'  // 内饰
  },
  {
    value: 'YFPO',
    label: 'YFPO'     // 彼欧
  },
  {
    value: 'YFAYM',
    label: 'YFAYM'
  },
  {
    value: 'YFAS',
    label: 'YFAS'     // 座椅
  },
  {
    value: 'YFSS',
    label: 'YFSS'     // 安全
  },
  {
    value: 'YFVIC',
    label: 'YFVIC'       // 电子
  }
]

export const MONTH_NAME = [
  {
    value: '1',
    label: 'Jan.'
  },
  {
    value: '2',
    label: 'Feb.'
  },
  {
    value: '3',
    label: 'Mar.'
  },
  {
    value: '4',
    label: 'Apr.'
  },
  {
    value: '5',
    label: 'May.'
  },
  {
    value: '6',
    label: 'Jun.'
  },
  {
    value: '7',
    label: 'Jul.'
  },
  {
    value: '8',
    label: 'Aug.'
  },
  {
    value: '9',
    label: 'Sept.'
  },
  {
    value: '10',
    label: 'Oct.'
  },
  {
    value: '11',
    label: 'Nov.'
  },
  {
    value: '12',
    label: 'Dec.'
  }
]

export const BU_LIST2 = [
  {
    value: '701',
    label: '延锋内饰'
  },
  {
    value: 'YFSS',
    label: '延锋智能安全'
  },
  {
    value: 'YFJCI',
    label: '延锋安道拓'
  },
  {
    value: 'AYM',
    label: '延锋机械零部件'
  },
  {
    value: 'YF401',
    label: '延锋电子-汇总'
  },
  {
    value: 'YFPO(Consolidation)',
    label: '延锋彼欧(合并)'
  },
  {
    value: '',
    label: '所有'
  }
]
